import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderImporter  {
    _originalTypeClassName = "zERP.BO.PaymentOrderImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderImporter.translate = translateService;
}
this.PaymentOrderImporterKey = null;
this._key = this.PaymentOrderImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PaymentOrderImporterKey:any;
get PaymentOrderImporterKey(): any {
    return this._PaymentOrderImporterKey;
  }
set PaymentOrderImporterKey(value: any) {
    this._PaymentOrderImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaymentOrderImporterKey == null || $this.PaymentOrderImporterKey == 0;
            }


}